// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sortable-header[data-v-3d275eb2]:after{font-family:icomoon;font-weight:400;vertical-align:middle;display:inline-block}.sortable-header.asc[data-v-3d275eb2]:after{content:\"\"}.sortable-header.desc[data-v-3d275eb2]:after{content:\"\"}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
